// @format

import {showNotice} from './notice';
import 'jquery';
import 'summernote';
import {proceedSuccessNotice} from './notifier';

export function initProspectToggle(): void {
  $(document).on('change', '.bots-prospect-toggle', e => {
    const t = $(e.currentTarget);

    $.ajax({
      url: '/bots/' + t.data('bot-id') + '/prospects/' + t.data('id'),
      contentType: 'application/json; charset=UT-8',
      dataType: 'json',
      data: JSON.stringify({
        authenticity_token: $('[name="csrf-token"]').attr('content'),
        unreviewed: t.hasClass("reviewed"),
        bots_prospect: {
          rejected_at: !t.prop('checked') && new Date()
        },
      }),
      error: function(jqXHR, exception) {
        t.prop('checked', !t.prop('checked'));
      },
      success: () => {
        const reject_button = t
          .closest('tr')
          .find('.reject-reasons-wrap, .reject-prospect-button');
        if (t.prop('checked')) {
          reject_button.addClass('hide');
        } else {
          reject_button.removeClass('hide');
        }
      },
      type: 'PATCH',
    });
  });
}

export const initRejectReasonListener = () => {
  $(document).on('click', '.reject-reasons a', e => {
    e.preventDefault();
    const link = $(e.currentTarget);
    const wrapper = link.closest('.reject-reasons-wrap');
    if (link.hasClass('other')) {
      wrapper.find('.reject-reasons').addClass('hidden')
      wrapper.find('.reject-prospect-button').removeClass('hidden')
      initAddToBlockListener(wrapper);
    } else {
      sendRejectReason(`/add_reject_reason/${wrapper.data('id')}/${link.data('reason')}`, link, wrapper);
    }
  });
}

const initAddToBlockListener = (wrapper) => {
  wrapper.find('.reject-prospect-button').on('click', function (e) {
    e.preventDefault();
    const t = $(this)
    sendRejectReason(`/bots/${t.data('bot-id')}/prospects/${t.data('id')}/add_to_company_blocklist`, t, wrapper);
    $(this).text('Company added to block list')
  })
}

const sendRejectReason = (url, link, wrapper) => {
  $.ajax({
    url: url,
    data: {
      authenticity_token: $('[name="csrf-token"]').attr('content'),
    },
    type: 'PATCH',
    success: function() {
      link.addClass('checked')
      if (wrapper.hasClass("reject-reasons-wrap")){
        // wrapper.addClass('hide')
      }
    },
  });
}

export function initEditProspectListener(): void {
  $(document).on('click', '.edit-bots-prospect', e => {
    const botsProspectId = $(e.currentTarget).data('bots-prospect-id');
    $('.edit-form-' + botsProspectId).toggle('fast');
  });
  $(document).on('click', '.customize-message-button', e => {
    const $btnEle = $(e.currentTarget);
    const botsProspectId = $(e.currentTarget).data('bots-prospect-id');
    const $toggledEle = $('.custom-message-' + botsProspectId)
    
    if($toggledEle.is(':visible')) {
      $btnEle.removeClass('active');
    } else {
      $btnEle.addClass('active');
    }

    $toggledEle.toggle('fast');
  });
  
  $(document).on('click', '.delete-customized-message-button', e => {
    const customMessageId = $(e.currentTarget).data('custom-message-id');
    if (confirm('Are you sure?')) {
      fetch('/custom_messages/' + customMessageId + '/delete', {
        method: 'delete',
        credentials: 'same-origin',
        headers: {
          'X-CSRF-TOKEN': document
            .querySelector('meta[name="csrf-token"]')
            .getAttribute('content'),
          'Content-Type': 'application/json',
          Accept: 'application/json',
          'X-Requested-With': 'XMLHttpRequest',
        },
      }).then(_ => location.reload());
    }
  });

  $(document).on('click', '.checked-bots-prospect', function(e) {
    e.preventDefault();
    let url = $(e.currentTarget).attr('href');
    const $ele = $(this);

    if (confirm('Are you sure?')) {
      $.ajax({
        url: url,
        data: {
          authenticity_token: $('[name="csrf-token"]').attr('content'),
        },
        type: 'PATCH',
        success: function(res) {
          const checkedBy = res['checked_by']
          const checkedAt = res['checked_at']
          $ele.replaceWith(`<div><strong>${checkedBy}</strong></div><div>${checkedAt}</div>`)
        },
      });
    }
  });
}

export function initPhoneCompletedListener(): void {
  $(document).on('click', '.phone-completed', e => {
    const target = $(e.currentTarget);
    target.css('display', 'none');
    const botsProspectId = target.data('bots-prospect-id');
    $('.phone-completed-triage-' + botsProspectId).show();
  });
}

export function initEmailsReceived(): void {
  $(document).on('change', '#emails_received', e => {
    const target = $(e.currentTarget);
    window.location.href =
      '/bots/' +
      target.data('botId') +
      '/prospects/phone/?emails_received=' +
      $('#emails_received option:selected').val();
  });
}

export function initReApproachedBtn(): void {
  $(".manually-unblocked").on('click', function () {
    const thisObj = $(this)
    thisObj.closest('td').find('.manually-re-unblocked').removeClass("active")
    thisObj.closest('td').find('.manually-unblocked').addClass("active");
  })
  $(".manually-re-unblocked").on('click', function () {
    const thisObj = $(this)
    thisObj.closest('td').find('.manually-re-unblocked').addClass("active")
    thisObj.closest('td').find('.manually-unblocked').removeClass("active");
  })
}

export function initCheckedBotsProspect(): void {
  $("#check-all-prospects").on("ajax:success", function(event) {
    const target = event.currentTarget;
    const detail = event.detail[0]
    const checkedBy = detail.checked_by
    const checkedAt = detail.checked_at
    $(target).addClass("disabled")
    $(".checked-bots-prospect").replaceWith(`<div class="intro--reviewed-by">Reviewed by <strong>${checkedBy}</strong> at ${checkedAt}</div>`)
  })
}

export function initBotProspectHistory(): void {
  $(".history-button").on("click", function(event) {
    const target = event.currentTarget;
    const botsProspectId = target.dataset.toggleId;
    const $historyElem = $(`#${botsProspectId}`);

    if($historyElem.is(':visible')) {
      $(target).removeClass('active');
    } else {
      $(target).addClass('active');
    }
    // $historyElem.toggle('fast');
  });
}

export function initPersonalizedMessage(): void {
  const $sequenceBtns = $('input[name="custom_message[sequence_id]"]');

  $sequenceBtns.each(function() {
    $(this).off('click').on('click', function() {
      const $form = $(this).closest('form');
      $form.find('#custom_message_subject').val($(this).data('subject'));
      $form.find('#custom_message_body').summernote("code", $(this).data('body'));
    });
  });
}

export function initSendConnectionRequestLinkedInModal(): void {
  let currentBotsProspectId: string | null = null
  let currentBotId: string | null = null
  let currentSendUrl: string | null = null

  $(document).on('click', '.view-invitation-form', function () {
    const $button = $(this);
    const modal = $('#sendConnectionRequestLinkedInModal')

    currentBotsProspectId = $button.data('bots-prospect-id')
    currentBotId = $button.data('bot-id')
    currentSendUrl = $button.data('send-url')
    const prospectName = $button.data('prospect-name')

    modal.find('.initial-content').show()
    modal.find('.note-form-content').hide()
    modal.find('.modal-title').text('Add a note to your invitation?')

    modal.find('.prospect-name-placeholder').text(prospectName)

    modal.find('.write-with-ai-button').attr('data-bot-id', currentBotId)
    modal.find('.write-with-ai-button').attr('data-bots-prospect-id', currentBotsProspectId)

    modal.find('.invitation-note-textarea').val('')
    updateCharacterCount(modal.find('.invitation-note-textarea')[0] as HTMLTextAreaElement)

    modal.modal('show')
  })

  // Handle the "Add a note" button click
  $(document).on('click', '.add-note-button', function() {
    const modal = $('#sendConnectionRequestLinkedInModal')

    if (!currentSendUrl) return

    modal.find('.invitation-form').attr('action', currentSendUrl)

    modal.find('.initial-content').hide()
    modal.find('.note-form-content').show()
    modal.find('.modal-title').text('Add a note to your invitation')

    modal.find('.invitation-note-textarea').focus()
  });

  // Handle the "Send without note" button click
  $(document).on('click', '.send-without-note-button', function() {
    if ($(this).hasClass('sending')) { return false }

    if (!currentSendUrl) return

    const $button = $(this)
    const originalText = $button.text()

    $button.addClass('sending')
      .prop('disabled', true)
      .html(`<span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span> Sending...`)

    $.ajax({
      url: currentSendUrl,
      method: 'POST',
      data: {
        authenticity_token: $('[name="csrf-token"]').attr('content')
      },
      success: function(response) {
        $('#sendConnectionRequestLinkedInModal').modal('hide')
        location.reload()
      },
      error: function(xhr) {
        const errorMessage = xhr.responseJSON?.alert || "Failed to send connection request"
        alert(errorMessage)
      },
      complete: function() {
        $button.removeClass('sending')
          .prop('disabled', false)
          .text(originalText)
      }
    })

    return false
  })

  // Cancel sends with a note form
  $(document).on('click', '.cancel-note-button', function() {
    const modal = $('#sendConnectionRequestLinkedInModal')

    modal.find('.note-form-content').hide()
    modal.find('.initial-content').show()
    modal.find('.modal-title').text('Add a note to your invitation?')

    modal.find('.invitation-note-textarea').val('')
    updateCharacterCount(modal.find('.invitation-note-textarea')[0] as HTMLTextAreaElement)
  })

  // Character counter for textarea
  $(document).on('input', '.invitation-note-textarea', function() {
    updateCharacterCount(this)

    const modal = $('#sendConnectionRequestLinkedInModal')
    const submitButton = modal.find('input[type="submit"]')

    const value = $(this).val()
    const hasContent = typeof value === 'string' && value.trim().length > 0

    submitButton.prop('disabled', !hasContent)
  })

  // Handle the "Send with note" button click
  $(document).on("ajax:beforeSend", ".invitation-form", function() {
    const form = $(this)
    form.find('input[type="submit"]').addClass('d-none')
    form.find('.spinner-border').removeClass('d-none')
  })

  $(document).on("ajax:complete", ".invitation-form", function() {
    const form = $(this)
    form.find('input[type="submit"]').removeClass('d-none').prop('disabled', false)
    form.find('.spinner-border').addClass('d-none')
  })

  $(document).on('ajax:success', '.invitation-form', function(event) {
    $('#sendConnectionRequestLinkedInModal').modal('hide')
    location.reload()
  })

  $(document).on('ajax:error', '.invitation-form', function(event) {
    const data = event.detail[0]
    const errorMessage = data?.alert || "Failed to send connection request"
    alert(errorMessage)
  })
}

function updateCharacterCount(textarea: HTMLTextAreaElement): void {
  const currentLength = textarea.value.length
  const maxLength = 300
  const counter = $(textarea).closest('.note-form-content').find('.current-count')

  counter.text(currentLength);

  if (currentLength > maxLength * 0.9) {
    counter.addClass('text-warning')
  } else {
    counter.removeClass('text-warning')
  }

  if (currentLength >= maxLength) {
    counter.addClass('text-danger').removeClass('text-warning')
  } else {
    counter.removeClass('text-danger')
  }
}

$(document).on("ajax:success", ".unipile-connect-button", function(event) {
  console.log("EEE", event);
  const data = event.detail[0];
  $(this).addClass("success").attr("disabled", "disabled");
  $(this).find("i").removeClass("fa-spin").addClass("text-primary");
  $(this).find("i.fa-long-arrow-alt-right").removeClass("hidden");
  $(this).attr("title", "Connection Request Sent " + new Date().toLocaleDateString("en-GB").replace(/\//g, "-"));
});

$(document).on("ajax:error", ".unipile-connect-button", function(event) {
  console.log("EEE", event);
  const data = event.detail[0];
  const errorMessage = data?.alert || "Failed to send connection request";
  alert(errorMessage);
  $(this).removeClass("disabled");
  $(this).find("i").removeClass("fa-spin text-success");
});

$(document).on("ajax:beforeSend", ".unipile-connect-button", function() {
  $(this).addClass("disabled");
  $(this).find("i").addClass("fa-spin");
});


export function initFetchPhoneButton(): void {
  $(document).off('click', '.fetch-phone-btn').on('click', '.fetch-phone-btn', e => {
    const $target = $(e.target);
    const $pop = $target.closest('.popover');
    const popId = $pop.attr('id');
    const $trigger = $('[aria-describedby="' + popId + '"]');
    const $spinner = $('<div><i class="fas fa-spinner fa-spin"></i> Fetching...</div>');
    $target.replaceWith($spinner);

    $.ajax({
      url: `/prospects/${$target.data('prospect-id')}/fetch_phone`,
      type: 'POST',
      success: function(data) {
        let content = '';
        if(data.status == 'found') {
          content = `<div class='phone-number'>${data.phone_number}</div>`
        } else if (data.status == 'not_found') {
          content = `<div class="no-phone-number">${data.phone_number}</div>`
        }

        $trigger.attr('data-content', content);
        $spinner.replaceWith(content);

        if (data.status == 'found') {
          $trigger.addClass('found');
        } else if (data.status == 'not_found') {
          $trigger.addClass('not-found');
        }
      },
      error: function() {
        alert('Failed to fetch phone number');
        $spinner.replaceWith($target);
      }
    });
  });

  $(document).on("click", ".close-popover", function(e) {
    $(e.target).closest('.popover').popover("hide");
  });
}

export function initStatusCallingDropdown(): void {
  $(document).on("change", ".status_calling", function() {
    const $selectEle = $(this);
    const botsProspectId = $selectEle.data('bots-prospect-id');
    const statusCalling = $selectEle.val();

    $.ajax({
      url: `/bots_prospects/${botsProspectId}/update_status_calling`,
      type: 'PUT',
      data: {
        bots_prospect: {
          status_calling: statusCalling
        }
      },
      success: function(data) {
        $selectEle.removeClass().addClass(String(`form-control status_calling ${statusCalling}`));
        proceedSuccessNotice(data);
      }
    });
  });
}

$(document).on("ajax:beforeSend", ".unipile-verify-button", function() {
  $(this).addClass("disabled")
  $(this).find("i.fa-long-arrow-alt-right").addClass("hidden")
  $(this).find("i").addClass("fa-spin")
})

$(document).on("ajax:success", ".unipile-verify-button", function(event) {
  $(this).addClass("success").attr("disabled", "disabled")
  $(this).find("i").removeClass("fa-spin").addClass("text-success")
  $(this).attr("title", "Candidate already in your network")
})

$(document).on("ajax:error", ".unipile-verify-button", function(event) {
  const data = event.detail[0]
  const errorMessage = data?.alert || "Failed to verify connection request"
  alert(errorMessage)
  $(this).removeClass("disabled")
  $(this).find("i").removeClass("fa-spin text-success")
})

export function initWriteWithAIButton(): void {
  $(document).off('click', '.write-with-ai-button');

  $(document).on('click', '.write-with-ai-button', function () {
    const botId = $(this).data('bot-id')
    const prospectId = $(this).data('bots-prospect-id')
    const button = this

    button.disabled = true
    button.innerHTML = '<i class="fas fa-spinner fa-spin"></i> Generating...'

    $.ajax({
      url: `/bots/${botId}/prospects/${prospectId}/write_with_ai`,
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content')
      },
      success: function (data) {
        const form = button.closest('form')
        if (!form) return

        const messageTextarea = form.querySelector('textarea[name="bots_prospect_unipile_request[invitation_note]"]');
        if (messageTextarea) {
          (messageTextarea as HTMLTextAreaElement).value = data.message

          updateCharacterCount(messageTextarea)
          $('.send-with-note-button').prop('disabled', false)
        }
      },
      error: function (xhr: any) {
        let errorMessage = 'Failed to generate AI message. Please try again.'
        if (xhr.responseJSON && xhr.responseJSON.error) {
          errorMessage = 'Error generating AI message: ' + xhr.responseJSON.error
        }
        alert(errorMessage)
      },
      complete: function () {
        button.disabled = false
        button.innerHTML = '<i class="fas fa-robot"></i> Write with AI'
      }
    })
  })
}
